import { validator } from "@/utils/validator";

/** 登録番号の形式: YY登-XXXXXX（例: 21登-000001） */
export const RSO_LICENSE_NUMBER_REGEX = /^\d{2}登-\d{6}$/;
export const RSO_LICENSE_NUMBER_ERROR_MESSAGE = "無効な登録番号の形式です。期待される形式: YY登-XXXXXX";

export const rsoSchema = validator.object().shape({
  id: validator.number().nullable().label("組織ID").notRequired(),
  name: validator.string().trim().emptyToNull().label("登録支援機関の名称").max(60).required(),
  licenseNumber: validator
    .string()
    .trim()
    .emptyToNull()
    .label("登録番号")
    .matches(RSO_LICENSE_NUMBER_REGEX, { message: RSO_LICENSE_NUMBER_ERROR_MESSAGE, excludeEmptyString: true })
    .nullable()
    .notRequired(),
  hiddenIndustryIds: validator.array().of(validator.number().required()).default([]).notRequired(),
});
